module.exports = __webpack_public_path__ + "static/media/offline-noData.addaf811.png";